var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
// SPDX-License-Identifier: AGPL-3.0-only
import { useState } from "react";
import { useApolloClient } from "@apollo/client";
import { Button, defaultExporter, useDataProvider, useListContext, useNotify, useTranslate, } from "react-admin";
import DownloadIcon from "@mui/icons-material/Download";
import { ListActions } from "@/components/ListActions";
import { FORENSIC_NETWORK_SUMMARY } from "@/queries/ForensicNetwork";
import { collectForensicExport } from "@/services/ForensicExport";
import { IPermissions } from "@/types/keycloak";
export var ForensicExportActions = function (_a) {
    var electionEventId = _a.electionEventId, electionId = _a.electionId, preferenceKey = _a.preferenceKey, _b = _a.selectedOnly, selectedOnly = _b === void 0 ? false : _b;
    var _c = useListContext(), filterValues = _c.filterValues, selectedIds = _c.selectedIds, total = _c.total;
    var client = useApolloClient();
    var dataProvider = useDataProvider();
    var notify = useNotify();
    var translate = useTranslate();
    var _d = useState(false), exporting = _d[0], setExporting = _d[1];
    var exportRows = function () { return __awaiter(void 0, void 0, void 0, function () {
        var rows, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setExporting(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, collectForensicExport(function (offset, limit) { return __awaiter(void 0, void 0, void 0, function () {
                            var data;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, client.query({
                                            query: FORENSIC_NETWORK_SUMMARY,
                                            variables: {
                                                electionEventId: electionEventId,
                                                electionId: electionId !== null && electionId !== void 0 ? electionId : filterValues.election_id,
                                                ip: filterValues.ip,
                                                country: filterValues.country,
                                                offset: offset,
                                                limit: limit,
                                                operation: "export",
                                            },
                                            fetchPolicy: "no-cache",
                                            context: { headers: { "x-hasura-role": IPermissions.FORENSIC_READ } },
                                        })];
                                    case 1:
                                        data = (_a.sent()).data;
                                        return [2 /*return*/, data.forensic_network_summary.payload];
                                }
                            });
                        }); }, selectedOnly ? selectedIds : undefined)];
                case 2:
                    rows = _b.sent();
                    return [4 /*yield*/, defaultExporter(rows, function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                            return [2 /*return*/, ({})];
                        }); }); }, dataProvider, "forensic-network")];
                case 3:
                    _b.sent();
                    return [3 /*break*/, 6];
                case 4:
                    _a = _b.sent();
                    notify("ballotPrivacy.forensic.exportError", { type: "error" });
                    return [3 /*break*/, 6];
                case 5:
                    setExporting(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    if (selectedOnly)
        return selectedIds.length ? (_jsx(Button, { onClick: function () { return void exportRows(); }, disabled: exporting, label: "ra.action.export", "aria-label": translate("ra.action.export"), children: _jsx(DownloadIcon, {}) })) : null;
    return (_jsx(ListActions, { withImport: false, preferenceKey: preferenceKey, doExport: function () { return void exportRows(); }, isExportDisabled: exporting || !total }));
};
